import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const loginStudent = async (username, password) => {
  const { data } = await axiosInstance.post("/student-auth/login", { username, password });
  return data;
};

export const getCurrentStudent = async () => {
  const { data } = await axiosInstance.get("/student-auth/me");
  return data;
};

export const logoutStudent = async () => {
  const { data } = await axiosInstance.post("/student-auth/logout");
  return data;
};

export const changeStudentPassword = async (payload) => {
  const { data } = await axiosInstance.post("/student-auth/change-password", payload);
  return data;
};
